import { Text } from "@chakra-ui/react";

interface ErrorComponentProps {
  text: string;
}

export const ErrorComponent = ({ text }: ErrorComponentProps) => (
  <Text p={4} bg="tomato" color="white" borderRadius="md">
    {text}
  </Text>
);
